import React from 'react'
import { Link } from 'react-router-dom'

import './menu.css'

function Menu() {
    
    return (
    
        <div className='--menu'>

            <ul className='--nav'>
                <li className='--item'>
                    <Link className='--a --a-br' to={''}>
                        <span>Iniciar Sesión</span>
                    </Link>
                </li>

                <li className='--item'>
                    <Link className='--a --a-bg' to={''}>
                        <span>Crear cuenta</span>
                    </Link>
                </li>
            </ul>

        </div>
    
    )

}

export default Menu